module.exports = __webpack_public_path__ + "static/img/phone-ES.563a332.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phone-ES.png
// module id = UlvR
// module chunks = 1